(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ramda"), require("angular"), require("is-plain-object"), require("@darkobits/interface"), require("angular-messages"));
	else if(typeof define === 'function' && define.amd)
		define(["ramda", "angular", "is-plain-object", "@darkobits/interface", "angular-messages"], factory);
	else if(typeof exports === 'object')
		exports["Formation"] = factory(require("ramda"), require("angular"), require("is-plain-object"), require("@darkobits/interface"), require("angular-messages"));
	else
		root["Formation"] = factory(root["R"], root["angular"], root["isPlainObject"], root["Interface"], root[undefined]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_16__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition